import { guardNumber } from "../numbers";
import type { CalculationFormServiceItem } from "../schemas";
import type { NullableFields } from "../types";
import { calculateServiceCalculationItemTotal } from "./calculate-service-calculation-item-total";

/**
 * Calculates the grand total for a calculation by summing its root-level items only.
 * Nested items (e.g. a block's children) are already folded into their parent's
 * rolled-up total, so summing every item flat would double-count them.
 *
 * @param services - The full flat list of calculation items.
 * @returns The calculation's grand total.
 */
export function calculateCalculation(services: NullableFields<CalculationFormServiceItem>[]) {
	let result = 0;
	if (!Array.isArray(services)) return result;
	const rootItems = services.filter((service) => !service.parentServiceCalculationItemId);
	for (const service of rootItems) {
		if (service.isEventualPosition) continue;
		result += guardNumber(calculateServiceCalculationItemTotal(service, services));
	}

	return result;
}
